import { useEffect, useRef } from "react";

export interface IdentityA11yAnnouncerProps {
  message?: string;
  type?: "error" | "success";
}

export function IdentityA11yAnnouncer({ message, type = "success" }: IdentityA11yAnnouncerProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!message || !ref.current) return;
    ref.current.textContent = message;
  }, [message, type]);

  const role = type === "error" ? "alert" : "status";
  return (
    <div
      ref={ref}
      id="sc-identity-a11y"
      className="sc-identity-a11y"
      role={role}
      aria-atomic
      aria-live={type === "error" ? "assertive" : "polite"}
    />
  );
}
